import React from "react";
import TableCell from "@mui/material/TableCell";
import MarkdownPreviewWithEditDialog from "../Markdown/MarkdownPreviewWithEditDialog";
import OverviewTable from "./OverviewTable";

type Props = {
  setFormOfSurvey: React.Dispatch<React.SetStateAction<string | undefined>>
  formOfSurvey?: string
  setTargetDimension: React.Dispatch<React.SetStateAction<string | undefined>>
  targetDimension?: string
  setRater: React.Dispatch<React.SetStateAction<string | undefined>>
  rater?: string
  setAgeRange: React.Dispatch<React.SetStateAction<string | undefined>>
  ageRange?: string
  setItems: React.Dispatch<React.SetStateAction<string | undefined>>
  items?: string
  setProcessingTime: React.Dispatch<React.SetStateAction<string | undefined>>
  processingTime?: string
  setOpenAccess: React.Dispatch<React.SetStateAction<string | undefined>>
  openAccess?: string
}

export default function EditOverviewTable({
                                            setFormOfSurvey,
                                            formOfSurvey,
                                            setTargetDimension,
                                            targetDimension,
                                            setRater,
                                            rater,
                                            setAgeRange,
                                            ageRange,
                                            setItems,
                                            items,
                                            setProcessingTime,
                                            processingTime,
                                            setOpenAccess,
                                            openAccess
                                          }: Props) {
  return (
      <OverviewTable>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Erhebungsform" value={formOfSurvey}
                                         onChange={value => setFormOfSurvey(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Zieldimension" value={targetDimension}
                                         onChange={value => setTargetDimension(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Rater" value={rater}
                                         onChange={value => setRater(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Altersrange" value={ageRange}
                                         onChange={value => setAgeRange(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Items" value={items}
                                         onChange={value => setItems(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Bearbeitungsdauer" value={processingTime}
                                         onChange={value => setProcessingTime(value)}/>
        </TableCell>
        <TableCell>
          <MarkdownPreviewWithEditDialog title="Publikation" value={openAccess}
                                         onChange={value => setOpenAccess(value)}/>
        </TableCell>
      </OverviewTable>
  );
}